import React, { useEffect } from 'react';
import {
   Box,
   Typography,
   Card,
   MenuItem,
   FormControl,
   Select,
   TextareaAutosize,
   Dialog,
   Menu,
   Paper,
   ListItem,
   ListItemText,
   Alert,
   AlertTitle,
   List,
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import cost from '../../../assets/cost.svg';
import verticalMenu from '../../../assets/verticalMenu.svg';
import { Container } from './style';
import backImg from '../../../assets/back.svg';
import contactImg from '../../../assets/FAB.png';
import styled from '@emotion/styled';
import ScheduleDate from '../../../components/message/scheduleMessage/ScheduleDate';
import MessageSummary from '../../../components/message/messageHome/MessageSummary';
import { messageSelector } from '../../../components/utils/selectors/selectors';
import { useDispatch, useSelector } from 'react-redux';
import {
   draftmessage,
   fetchsenderIDs,
   getMsgCost,
   resetCreated,
   schedulemessage,
   selectSenderId,
   resetSelectedContacts,
   clearSelectedContent,
   resetSelectedId,
} from '../../../components/app/features/message/messageSlice';
import GroupContent from '../message/GroupContent';
import ContactContent from '../message/ContactContent';
import MessageContact from '../messageContact';
import Success from './Success';
import { toast } from 'react-toastify';

const Textarea = styled(TextareaAutosize)(
   ({ theme }) => `
		width: 100%;
		min-height: 150px;
      padding: 10px;
		border: 1px solid #A1A1A1;
		border-radius:5px;
		font-size:1rem;
       background: white;
       color: #49454F;
		margin-top: 2rem;
       &.placeholer{
        color: red;
       }
		&:focus {
      outline: none;
      box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.1);
    },
     `
);
const DropDown = styled(Menu)(
   ({ theme }) => `
	position: absolute;
	right: 0;

& .MuiPopover-paper {
	border-radius:0;
}
& .MuiList-root, & .MuiMenu-list {
	border-radius:0;
}

	`
);
const Activity = styled(MenuItem)(
   ({ theme }) => `
	min-height:unset;
	padding:5px 0 ;
   box-sizing: border-box;
   white-space: nowrap;
	width: 160px;
	font-weight:700;
	border-radius:0;
	`
);

const ScheduleMessage = () => {
   const selector = useSelector(messageSelector);
   const dispatch = useDispatch();
   const [anchorEl, setAnchorEl] = React.useState(null);
   const [period, setPeriod] = React.useState(false);
   const [draftOpen, setDraftOpen] = React.useState(false);
   const [openSummary, setOpenSummary] = React.useState(false);
   const [add, setAdd] = React.useState(false);
   const [open, setOpen] = React.useState(false);
   const [date, setDate] = React.useState('');
   const [action, setAction] = React.useState('');
   const [senderId, setSenderId] = React.useState(selector?.selectedSenderId);
   const [text, setText] = React.useState(selector?.selectedContent);
   const actions = ['Save to Drafts'];
   const [page, setPage] = React.useState(1);
   const [numOfContacts, setNumOfContacts] = React.useState(0);

   const closePeriod = () => setPeriod(false);

   useEffect(() => {
      if (selector?.selectedContent.length > 0) {
         setPeriod(true);
      }
      dispatch(clearSelectedContent());
   }, []);

   const handleTextAreaChange = (e) => {
      const { value } = e.target;
      if (text.length > 0) {
         setPage(Math.ceil(text.length / 160));
      } else if (text === '') {
         setPage(1);
      } else {
         setPage(1);
      }
      setText(value);
   };
   const handleChange = (event) => {
      setSenderId(event.target.value);
      dispatch(selectSenderId({ senderId: event.target.value }));
   };
   const handleMenu = (value) => {
      setAction(value);
      setAnchorEl(null);
   };

   React.useEffect(() => {
      if (action === 'Save to Drafts') {
         setDraftOpen(true);
      }
   }, [action === 'Save to Drafts']);

   const getTime = (value) => {
      console.log('Selected Date ', value);
      setDate(value);
      setPeriod(false);
   };

   React.useEffect(() => {
      if (!selector.senderIds || selector.senderIds.length < 1) {
         dispatch(fetchsenderIDs());
      }
   }, []);
   const groupIds = selector?.selectedGroups.map((group) => group.id);
   const contactIds = selector?.selectedContacts.map((contact) => contact.id);
   const numbers = selector?.selectedNumbers;

   const isButtonDisabled =
      !senderId ||
      text.trim() === '' ||
      (contactIds.length === 0 &&
         groupIds.length === 0 &&
         numbers.length === 0);

   React.useEffect(() => {
      if (selector.scheduled === true) {
         setOpen(true);
      } else {
         setOpen(false);
      }
   }, [selector.scheduled === true]);

   const schedule = () => {
      dispatch(
         schedulemessage({
            content: text,
            senderId: senderId,
            scheduledAt: date,
            contactids: contactIds,
            groupids: groupIds,
            numbers,
         })
      );
      setText('');
      setDate('');
      dispatch(resetSelectedId());
   };

   const currentDate = new Date().toISOString();
   const draft = () => {
      if (text !== '') {
         dispatch(
            draftmessage({
               content: text,
               senderId: senderId,
               scheduledAt: currentDate,
               contactids: contactIds,
               groupids: groupIds,
               numbers,
            })
         );
         window.history.back();
      } else {
         toast.info('type a message');
      }
   };

   const setClose = () => setAnchorEl(false);

   React.useEffect(() => {
      dispatch(
         getMsgCost({
            content: '',
            senderId: senderId,
            scheduledAt: date,
            contactids: contactIds,
            groupids: groupIds,
            numbers,
         })
      );
   }, [selector?.selectedContacts || selector?.selectedGroups]);

   React.useEffect(() => {
      if (selector.msgCost?.dNDCount || selector.msgCost?.nonDNDCount) {
         setNumOfContacts(
            selector.msgCost.dNDCount + selector.msgCost.nonDNDCount
         );
      } else {
         setNumOfContacts(0);
      }
   }, [selector.msgCost]);

   const resetMsgSummary = () => {
      setOpenSummary(false);
   };

   const maxCharactersPerPage = 160;
   const calculatePageCount = (text) => {
      return Math.ceil(text.length / maxCharactersPerPage);
   };
   const pageCount = calculatePageCount(text);
   const remainingCharacters =
      maxCharactersPerPage - (text.length % maxCharactersPerPage);

   return (
      <Container>
         <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <Paper
               elevation={1}
               sx={{
                  width: '90%',
                  maxWidth: '635px',
                  p: 2,
                  bgcolor: '#fff9e6',
                  border: '1px solid #FFC200',
               }}
            >
               <Typography
                  className="font-cormorant"
                  variant="h6"
                  component="h2"
                  sx={{
                     color: '#2E2C21',
                     fontWeight: '600',
                     fontSize: '1.4rem',
                  }}
               >
                  Delivery Notice
               </Typography>

               <Typography
                  variant="body2"
                  sx={{ mb: 2, color: '#585548', fontWeight: '400' }}
               >
                  In compliance with NCC regulations, messages sent between 8PM
                  and 8AM will be delayed and delivered at the next day.
               </Typography>

               <Typography
                  variant="body2"
                  sx={{ color: '#585548', fontWeight: '400' }}
               >
                  To make sure your messages get delivered without delay:
               </Typography>

               <List dense sx={{ pl: 0, py: 0, fontWeight: '400' }}>
                  <ListItem sx={{ py: 0, px: 0, minHeight: 'auto' }}>
                     <ListItemText
                        primary="Send before 8PM"
                        primaryTypographyProps={{
                           variant: 'body2',
                           color: '#585548',
                        }}
                     />
                  </ListItem>
                  <ListItem sx={{ py: 0, px: 0, minHeight: 'auto' }}>
                     <ListItemText
                        primary="Or schedule for after 8AM"
                        primaryTypographyProps={{
                           variant: 'body2',
                           color: '#585548',
                        }}
                     />
                  </ListItem>
               </List>

               <Alert
                  severity="warning"
                  icon={<WarningIcon />}
                  sx={{
                     fontWeight: '700',
                     fontSize: '0.9rem',
                     color: '#2E2C21',
                     backgroundColor: 'transparent',
                     padding: 0,
                     boxShadow: 'none',
                     alignItems: 'center',
                     '& .MuiAlert-message': {
                        padding: 0,
                     },
                     '& .MuiAlert-icon': {
                        alignItems: 'center',
                        marginTop: 0,
                     },
                  }}
               >
                  <div style={{ fontWeight: '700', fontSize: '0.7rem' }}>
                     We are not responsible for delivery issues or blocked
                     messages during restricted hours.
                  </div>
               </Alert>
            </Paper>
         </Box>
         <Card
            sx={{
               width: { xs: '95%', sm: '90%' },
               maxWidth: '655px',
               minHeight: { xs: '70vh', sm: '80vh' },
               margin: '0 auto',
               marginTop: { xs: '1rem', sm: '2rem' },
               position: 'relative',
               boxShadow:
                  '0px 1px 2px rgba(0, 0, 0, 0.3), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)',
               padding: { xs: '15px', sm: '20px' },
               background: 'white',
            }}
         >
            <Box
               sx={{
                  margin: '0 auto',
                  marginTop: '1rem',
                  border: '1px solid transparent',
                  position: 'relative',
               }}
            >
               <img
                  src={backImg}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '40px',
                     cursor: 'pointer',
                     top: '10px',
                     // border: '1px solid',
                  }}
                  onClick={() => {
                     if (text !== '') {
                        setDraftOpen(true);
                     } else {
                        window.history.back();
                     }
                  }}
               />
               <DropDown
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={setClose}
                  MenuListProps={{
                     'aria-labelledby': 'basic-button',
                  }}
               >
                  {actions.map((action, index) => (
                     <Activity
                        key={index}
                        onClick={(e) => handleMenu(e.target.innerText)}
                     >
                        {action}
                     </Activity>
                  ))}
               </DropDown>

               <img
                  src={verticalMenu}
                  alt="back"
                  style={{
                     position: 'absolute',
                     width: '30px',
                     top: '10px',
                     right: 0,
                     filter:
                        'invert(27%) sepia(11%) saturate(7243%) hue-rotate(207deg) brightness(94%) contrast(88%)',
                     cursor: 'pointer',
                  }}
                  onClick={(e) => setAnchorEl(e.currentTarget)}
               />
               <Typography
                  sx={{
                     width: '100%',
                     margin: '0 auto',
                     fontWeight: 600,
                     fontSize: {
                        xs: '2rem',
                        sm: '1.5rem',
                        md: '2rem',
                        lg: '2.3rem',
                     },
                     color: '#2E2C21',
                     marginTop: '0rem',
                     textAlign: 'center',
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                  }}
                  className="font-cormorant"
               >
                  Schedule Message
               </Typography>

               <Typography
                  sx={{
                     margin: '1.5rem 0 0.5rem 0',
                     fontWeight: 400,
                     fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' },
                     color: '#2E2C21',
                     marginTop: '2rem',
                  }}
               >
                  Sender ID
               </Typography>
               <FormControl fullWidth>
                  <Select
                     id="demo-simple-select"
                     value={senderId}
                     onChange={handleChange}
                     sx={{
                        backgroundColor: '#fff',
                        fontWeight: 600,
                        padding: '25px 0 !important',

                        '& .MuiOutlinedInput-notchedOutline': {
                           borderColor: '#E5E5E5',
                        },
                     }}
                  >
                     {selector?.senderIds ? (
                        selector?.senderIds
                           .filter((x) => x.status == 'approved')
                           .map((senderId, index) => (
                              <MenuItem value={senderId?.senderId} key={index}>
                                 {senderId?.senderId}
                              </MenuItem>
                           ))
                     ) : (
                        <MenuItem value={1}>No Sender Ids</MenuItem>
                     )}
                  </Select>
               </FormControl>

               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                  }}
               >
                  <Typography
                     sx={{
                        margin: '1.5rem 0 0.5rem 0',
                        fontWeight: 400,
                        fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' },
                        color: '#2E2C21',
                     }}
                  >
                     Recipients
                  </Typography>
                  <Typography
                     sx={{
                        margin: '1.5rem 0 0 0',
                        fontWeight: 400,
                        color: '#374da0',
                        cursor: 'pointer',
                     }}
                     onClick={() => {
                        dispatch(resetSelectedContacts());
                     }}
                  >
                     Clear
                  </Typography>
               </Box>
               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     position: 'relative',
                  }}
               >
                  <Box
                     sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        alignContent: 'flex-start',
                        bgcolor: 'background.paper',
                        maxHeight: 10,
                        border: '1px solid #E5E5E5',
                        minHeight: { xs: '50px', sm: '60px' },
                        background: '#fff',
                        borderRadius: '5px',
                        padding: { xs: '8px', sm: '10px' },
                        paddingRight: { xs: '35px', sm: '40px' },
                        overflow: 'auto',
                        width: '100%',
                        scrollbarWidth: 'thin',
                        scrollbarColor: 'grey',
                        // '&::-webkit-scrollbar': {
                        //    width: 0,
                        //    height: 0,
                        // },
                     }}
                  >
                     {selector?.selectedGroups.length > 0
                        ? selector?.selectedGroups.map((item, id) => (
                             <GroupContent key={id} item={item} />
                          ))
                        : null}
                     {selector.selectedContacts.length > 0
                        ? selector.selectedContacts.map((item, id) => (
                             <ContactContent key={id} item={item} />
                          ))
                        : null}

                     {selector.selectedNumbers.length > 0
                        ? selector.selectedNumbers.map((item, id) => (
                             <ContactContent key={id} item={{ number: item }} />
                          ))
                        : null}
                  </Box>
                  <img
                     src={contactImg}
                     alt="icon"
                     style={{
                        cursor: 'pointer',
                        marginLeft: '5px',
                     }}
                     onClick={() => setAdd(true)}
                  />
               </Box>

               <Typography
                  sx={{
                     margin: '1.2rem 0',
                     display: 'flex',
                     alignItems: 'center',
                     fontWeight: 400,
                     fontSize: { xs: '0.9rem', sm: '1rem' },
                     color: '#0040BF',
                     cursor: 'pointer',
                     width: '100%',
                     textDecoration: 'underline',
                     flexWrap: { xs: 'wrap', sm: 'nowrap' },
                     gap: { xs: 1, sm: 0 },
                  }}
                  onClick={() => {
                     dispatch(
                        getMsgCost({
                           content: text,
                           senderId: senderId,
                           scheduledAt: date,
                           contactids: contactIds,
                           groupids: groupIds,
                           numbers,
                        })
                     );
                     setOpenSummary(true);
                  }}
               >
                  <img src={cost} alt="icon" style={{ marginRight: '10px' }} />
                  View Pricing Info
               </Typography>

               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     alignItems: 'center',
                     marginTop: '1.3rem',
                     marginBottom: '1rem',

                     gap: { xs: 1, sm: 0 },
                     alignItems: { xs: 'flex-start', sm: 'center' },
                  }}
               >
                  <Typography
                     sx={{
                        fontWeight: 400,
                        fontSize: { xs: '1rem', sm: '1.1rem', md: '1.3rem' },
                        color: '#2E2C21',
                     }}
                  >
                     Your Message
                  </Typography>
               </Box>

               <Textarea
                  style={{ marginTop: '0 ' }}
                  name="desc"
                  aria-label="about"
                  minRows={1}
                  // placeholder='Enter message here...'
                  onChange={handleTextAreaChange}
                  value={text}
                  variant="outlined"
                  id="group_desc"
               />

               <Box
                  sx={{
                     display: 'flex',
                     justifyContent: 'space-between',
                     marginBottom: '2rem',
                     flexDirection: { xs: 'column', sm: 'row' },
                     gap: { xs: 1, sm: 0 },
                     alignItems: { xs: 'flex-start', sm: 'center' },
                  }}
               >
                  <Typography
                     sx={{
                        width: 'max-content',
                        color: '#58564d',
                        fontWeight: '400',
                        fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                     }}
                  >
                     {remainingCharacters}/{pageCount}
                  </Typography>
                  <Typography
                     sx={{
                        width: 'max-content',
                        color: '#58564d',
                        fontWeight: '400',
                        fontSize: { xs: '0.85rem', sm: '0.9rem', md: '1rem' },
                     }}
                  >
                     {`contacts:`}
                     {numOfContacts}
                  </Typography>
               </Box>

               <Box
                  sx={{
                     width: { xs: '100%', sm: '400px' },
                     height: { xs: '50px', sm: '45px' },
                     margin: '1.5rem auto',
                     borderRadius: '8px',
                     backgroundColor: isButtonDisabled ? '#b0b0b0' : '#0040bf',
                     color: '#fff',
                     display: 'flex',
                     justifyContent: 'center',
                     cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
                     opacity: isButtonDisabled ? 0.6 : 1,
                  }}
                  onClick={() => {
                     if (isButtonDisabled) return;
                     if (date === '' && text !== '' && numOfContacts > 0) {
                        setPeriod(true);
                     } else if (text === '') {
                        toast.info('type a message');
                     } else if (
                        contactIds.length === 0 &&
                        groupIds.length === 0 &&
                        numbers.length === 0
                     ) {
                        toast.info('select contacts');
                     } else if (
                        date !== '' &&
                        text !== '' &&
                        numOfContacts > 0
                     ) {
                        schedule();
                     }
                  }}
               >
                  <Typography
                     sx={{
                        textAlign: 'center',
                        width: { xs: '70%', sm: '80%' },
                        padding: '5px',
                        cursor: isButtonDisabled ? 'not-allowed' : 'pointer',
                        fontSize: { xs: '0.9rem', sm: '1rem' },
                        fontWeight: 600,
                        marginTop: 'auto',
                        marginBottom: 'auto',
                        color: '#fff',
                        background: isButtonDisabled ? '#b0b0b0' : '#0040bf',
                     }}
                  >
                     Schedule Message
                  </Typography>
               </Box>
               <Dialog onClose={() => setPeriod(false)} open={period}>
                  <ScheduleDate getTime={getTime} closePeriod={closePeriod} />
               </Dialog>
               <Dialog onClose={() => setAdd(false)} open={add}>
                  <MessageContact
                     contactText={'/send-message/select-contact'}
                     groupsText={'/send-message/select-group'}
                     pasteText={'/send-message/select-paste'}
                  />
               </Dialog>
               <Dialog
                  onClose={() => {
                     setAction('');
                     setDraftOpen(false);
                  }}
                  open={draftOpen}
               >
                  <Card sx={{ padding: '20px' }}>
                     <Typography
                        sx={{
                           textAlign: 'center',
                           marginBottom: '2rem',

                           fontWeight: '600',
                           fontSize: '1rem',
                        }}
                     >
                        You have not completed scheduling this message. How do
                        you want to proceed?
                     </Typography>
                     <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Typography
                           sx={{
                              color: '#374DAO',
                              fontWeight: '600',
                              marginRight: '1rem',
                              cursor: 'pointer',
                              fontSize: '1rem',
                           }}
                           onClick={() => draft()}
                        >
                           Save as Draft
                        </Typography>
                        <Typography
                           sx={{
                              color: '#374DAO',
                              fontWeight: '600',
                              cursor: 'pointer',
                              fontSize: '1rem',
                           }}
                           onClick={() => window.history.back()}
                        >
                           Discard
                        </Typography>
                     </Box>
                  </Card>
               </Dialog>
               <Dialog onClose={() => setOpenSummary(false)} open={openSummary}>
                  <MessageSummary resetMsgSummary={resetMsgSummary} />
               </Dialog>
               <Dialog
                  onClose={() => {
                     setOpen(false);
                     dispatch(resetCreated());
                  }}
                  open={open}
               >
                  <Success />
               </Dialog>
            </Box>
         </Card>
      </Container>
   );
};

export default ScheduleMessage;
